import axios from 'axios';
import type {
  IFindClientsOwnedByListingAgentsRequest,
  IFindClientsOwnedByListingAgentsResponse,
} from '@bb/contacts';

const findClientsOwnedByListingAgents = async (
  listingId: string,
  searchInput?: string,
) => {
  const config: IFindClientsOwnedByListingAgentsRequest = {
    url: '/contacts/client/listing_agents',
    params: { listingId, start: 0, limit: 20, searchInput },
    method: 'get',
  };

  const { data } =
    await axios.request<IFindClientsOwnedByListingAgentsResponse>(config);

  return data;
};

export default findClientsOwnedByListingAgents;
